import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-actions",
  templateUrl: "./med-icon-actions.component.html",
})
export class MedIconActionsComponent extends SvgMixinComponent {}
